import { API_EVENTS_URL } from './utils/config';
import { setup, setEnabled } from '@elevio/js-analytics';
import { getUser, getCompanyUid, getLanguageId, getIsCypressMode, } from './utils/globals';
export function setupAnalytics() {
    const isCypressMode = getIsCypressMode();
    if (process.env.NODE_ENV !== 'test' && !isCypressMode) {
        if (!API_EVENTS_URL)
            throw new Error('API_EVENTS_URL is not defined');
    }
    setup({
        enabled: false,
        interval: isCypressMode ? 0 : undefined,
        withUnload: !isCypressMode,
        endpointURL: API_EVENTS_URL,
        eventType: 'web-kb-event-2',
        fillEvent() {
            const user = getUser();
            return {
                app_lang: getLanguageId(),
                customer_uid: getCompanyUid(),
                user_uid: user.uid,
                user_email: user.email,
                user_loggedin: !!user.email,
            };
        },
    });
}
export function setAnalyticsIsEnabled(isEnabled) {
    // @ts-ignore previewMode is private
    if (window.previewMode === true) {
        // previewMode we never send events
        return;
    }
    setEnabled(isEnabled);
}
//# sourceMappingURL=analytics.js.map